import type { ComponentProps } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import { cn } from "../../../lib/utils";
import { Z_INDEX } from "../../../lib/z-index";
import { SelectScrollUpButton } from "./SelectScrollUpButton";
import { SelectScrollDownButton } from "./SelectScrollDownButton";

export type SelectContentProps = ComponentProps<typeof SelectPrimitive.Content> & {
  /** Which side of each item the selected checkmark sits on. Defaults to `"right"`. */
  indicatorSide?: "left" | "right";
};

export const SelectContent = ({
  className,
  children,
  position = "popper",
  indicatorSide = "right",
  ...props
}: SelectContentProps) => (
  <SelectPrimitive.Portal>
    <SelectPrimitive.Content
      data-slot="select-content"
      data-indicator-side={indicatorSide}
      className={cn(
        "group/select-content bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-[10px] border shadow-md",
        Z_INDEX.popover,
        position === "popper" &&
          "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        className
      )}
      position={position}
      {...props}
    >
      <SelectScrollUpButton />
      <SelectPrimitive.Viewport
        className={cn(
          "p-1",
          position === "popper" &&
            "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
        )}
      >
        {children}
      </SelectPrimitive.Viewport>
      <SelectScrollDownButton />
    </SelectPrimitive.Content>
  </SelectPrimitive.Portal>
);
